// Experience.js

import { Box, Flex } from '@chakra-ui/react';
import SEWhite from '../images/experience/SEWhite.svg';
import zenithLogo from '../images/experience/zenithLogo.svg';
import bbpLogo from '../images/experience/bbpLogo.png';
import velocitySquaredLogo from '../images/experience/velocitySquared.svg';
import ExperienceCard from '../components/ExperienceCard';
import { useState } from 'react';

const velocitySquaredWork = {
    jobTitle: "Jr. Software Developer",
    companyName: "Velocity Squared",
    startDate: "January 2026",
    endDate: "Present",
    description: "As a Jr. Software Developer, I'm responsible for web applications using modern frameworks and technologies. I'm excitedly learning the ropes of developing & maintaining enterprise software!",
    image: velocitySquaredLogo,
    projects: {},
    tags: ["Vue", "TypeScript", "React Native", "Mobile App Development", "Firebase", ".NET", "SQL", "Web App Development", "Expo", "Agile Development", "UI/UX", "Figma",],
    link: "https://www.velocity2.com/"
};

const zenithWork = {
    jobTitle: "Co-Founder/Chief Operating Officer",
    companyName: "Zenith Software",
    startDate: "September 2021",
    endDate: "Present",
    description: "Co-founded a startup at age 19 leading a team of software developers through 10+ projects. Focused on project management, company growth, client relations, and UI/UX designs while managing and mentoring a team of seven full-time developers. Led the development of multiple projects from conception to market launch, generating over $300,000 in revenue within four years.",
    image: zenithLogo,
    projects: {
        "Dio" : "https://zenithsoftware.dev/projectdescription?projectName=dio",
        "OnFire" : "https://zenithsoftware.dev/projectdescription?projectName=onfire%20athletes",
        "Cantaloupe" : "https://www.trycantaloupe.com/",
        "AURA": "https://www.auraadco.com/",
        "Earshot": "https://apps.apple.com/us/app/earshot-proximity-chat/id6471038992",
    },
    tags: ["Project Management", "Client Relations", "Technical Sales", "Invoicing", "Financial Management", "React", "TypeScript", "React Native", "Mobile App Development", "Expo", "Agile Development", "UI/UX", "Figma", "AWS"],
    link: "https://zenithsoftware.dev"
};

const speakEasyWork = {
    jobTitle: "Manager/Booking Agent/Bassist",
    companyName: "Speak Easy",
    startDate: "April 2021",
    endDate: "August 2025",
    description: "Led a group of musicians, managed performances, and oversaw releases. Developed a custom website using React and AWS, managed social media presence, and improved user experience through data-driven strategies. Skilled in multi-tasking, team management, and effective communication.",
    image: SEWhite,
    projects: {
        "speakeasybandbr.com": "https://www.speakeasybandbr.com/",
        "Instagram": "https://www.instagram.com/speakeasybandbr/",
        "Spotify": "https://open.spotify.com/artist/6DttflSZKb9uIGnXBDugdj?si=iF24Aa2-SeWOOXKzhUPadw",
    },
    tags: ["Management", "Leadership", "Social Media", "Marketing", "Advertising", "Team Coordination", "Client Relations", "Event Booking"],
    link: "https://www.speakeasybandbr.com/"
};

const bbpWork = {
    jobTitle: "Frontend Web Developer",
    companyName: "BBP Sales",
    startDate: "October 2021",
    endDate: "November 2022",
    description: "Gained foundational software development experience in a professional setting. Taught myself web development fundamentals and contributed to a large-scale employee portal project designed to automate inside sales.",
    image: bbpLogo,
    projects: {},
    tags: ["Web Development", "HTML", "CSS", "JavaScript", ".NET", "SQL", "Enterprise Software"],
    link: "https://www.bbpsales.com/"
};

export default function Experience() {
    const [is1Hovered, setIs1Hovered] = useState(false);
    const [is2Hovered, setIs2Hovered] = useState(false);
    const [is3Hovered, setIs3Hovered] = useState(false);
    const [is4Hovered, setIs4Hovered] = useState(false);
    const [hoverActive, setHoverActive] = useState(false);

    return (
        <Flex
            id="experience"
            flexDirection={"column"}
            alignItems="center"
            justifyContent="space-between"
            padding="5%"
            paddingLeft={"10%"}
            paddingRight={"10%"}
            backgroundColor={"black.200"}
            minW={"100%"}
        >
            <Box
                fontSize={"4xl"}
                fontFamily={"Source Code Pro Variable"}
                fontWeight="600"
                width={"100%"}
                textAlign={"center"}
                color={"white.200"}
                marginBottom={"2%"}
            >
                Work Experience
            </Box>

            <Flex
                flexDirection={{ base: "row", sm: "column" }}
                wrap={"wrap"}
                alignItems={"center"}
                justifyContent={"center"}
                width={"100%"}
                gap={5}
            >
                <ExperienceCard {...velocitySquaredWork}
                    isHovered={is1Hovered}
                    setIsHovered={setIs1Hovered}
                    hoverActive={hoverActive}
                    setIsHoverActive={setHoverActive}
                />
                <ExperienceCard {...zenithWork}
                    isHovered={is2Hovered}
                    setIsHovered={setIs2Hovered}
                    hoverActive={hoverActive}
                    setIsHoverActive={setHoverActive}
                />
                <ExperienceCard {...speakEasyWork}
                    isHovered={is3Hovered}
                    setIsHovered={setIs3Hovered}
                    hoverActive={hoverActive}
                    setIsHoverActive={setHoverActive}
                />
                <ExperienceCard {...bbpWork}
                    isHovered={is4Hovered}
                    setIsHovered={setIs4Hovered}
                    hoverActive={hoverActive}
                    setIsHoverActive={setHoverActive}
                />
            </Flex>
        </Flex>
    );
};
